import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './input.component.html',
  styleUrl: './input.component.css'
})
export class InputComponent {
  @Input() validateIn : {
    where : string,
    result : boolean
  } = {
    where : '',
    result : false
  };

  @Input() version : number = 1;
  @Input() type : string = 'text'; // ประเภทของ input
  @Input() placeholder : string = 'กรุณากรอกข้อมูล';
  @Input() format : string = ''; // รูปแบบการแสดงผล
  @Input() validateType : string = ''; // ประเภทการ validate
  @Input() validateName : string = ''; // ชื่อตำแหน่งที่ต้องการ validate
  @Input() max : string = '100'; // ค่าสูงสุด
  @Input() min : string = '1'; // ค่าต่ําสุด
  @Input() disabledValidate : boolean = false; // ค่าสถานะตรวจสอบ
  @Input() disabled : boolean = false; // ค่าสถานะปิด input
  @Input() readOnly : boolean = false; // ค่าสถานะอ่านเท่านั้น

  @Input() valueIn : any = ''; // ตัวแปรรับค่าเข้า
  @Output() valueOut = new EventEmitter<any>(); // ตัวแปรส่งค่าออก
  @Output() validateOut = new EventEmitter<{ where : string, result : boolean }>(); // ตัวแปร Validate ส่งค่าออก

  constructor(

  ) {
  }

  /* ----------------------------------------------------- Function ------------------------------------------------ */
  /* --- style --- */

  /* --- function --- */
  onChangeInput( value : any ) { 
    this.valueOut.emit(value);

    if( this.validateType == '' ) { 
      this.validateType = this.type
    }
    
    if (this.validateType === 'text') {
      this.onValidateText(this.validateName, value);
      //console.log('validateIn', this.validateName , '|' , this.validateName);
    }
    else if (this.validateType === 'number') {
      this.onValidateNumber(this.validateName, value);
    }
    else if (this.validateType === 'textNumber') {
      this.onValidateTextNumber(this.validateName, value);
    }
    else if (this.validateType === 'special') {
      this.onValidateSpecialChar(this.validateName, value);
    }

    this.validateOut.emit(this.validateIn);
    console.log('validateIn', this.validateIn);
  }

  /* ---- Validate ----*/
  onValidateText(where: string, value: string) {
    const check = value.match(/[^a-zA-Zก-๙\s]/g);
    if (value != '' && !check) {
      this.validateIn = { where: where, result: false }
    } else {
      this.validateIn = { where: where, result: true }
    }
  }

  onValidateNumber(where: string, value: string) {
    const check = value.match(/[^0-9]/g);
    if (value != '' && !check) {
      this.validateIn = { where: where, result: false }
    } else {
      this.validateIn = { where: where, result: true }
    }
  }

  onValidateTextNumber(where: string, value: string) {
    const check = value.match(/[^a-zA-Zก-๙0-9\s]/g);
    if (value != '' && !check) {
      this.validateIn = { where: where, result: false }
    } else {
      this.validateIn = { where: where, result: true }
    }
  }

  onValidateSpecialChar(where: string, value: string) {
    const check = value.match(/[^a-zA-Zก-๙0-9\s]/g);
    if (value == '' && !check) {
      this.validateIn = { where: where, result: false }
    } else {
      this.validateIn = { where: where, result: true }
    }
  }

  /* ----------------------------------------------------- ตัวอย่าง หน้าหลัก รับ ค่า  ------------------------------------------------ */
  receiveData(value: string) {
    console.log('ได้ค่าจากลูก:', value);
  }
  receiveValidate(value: any) {
    console.log('ได้ค่าจากลูก validate:', value);
  }
}
